/**
 * @file api.js
 * @desc 线索托管授权 - 律师端接口（/bp/platform/trustee）
 * 统一响应：{code: '0', msg, data}，成功判断 +code === 0
 */
import http from '@/utils/ajax';

// 托管状态 / 弹窗判断（同时服务授权确认弹窗、授权托管标签、解除弹窗）
export function getTrusteePopup() {
    return http.get('/bp/platform/trustee/popup');
}

// 关闭弹窗（当天不再展示）
export function dismissTrustee() {
    return http.post('/bp/platform/trustee/dismiss', {});
}

// 同意 / 拒绝授权：agree 1 同意、0 暂不接受
export function confirmTrustee(id, agree) {
    return http.post('/bp/platform/trustee/confirm', {id, agree});
}

// 解除托管
export function releaseTrustee(id) {
    return http.post('/bp/platform/trustee/release', {id});
}
